import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../theme';
import { useConfig } from '../../../../context';
import { PromoCodeStatus } from '../../../../PromoCode/types';
import { useRenderers } from '../../../../renderProps';
import MultiCity from './MultiCity/MultiCity';
import SearchFormPromoCode from './PromoCode/PromoCode';
import PayByMiles from './PayByMiles/PayByMiles';
import OfferHotels from './OfferHotels/OfferHotels';
import AdditionalLinks from './AdditionalLinks/AdditionalLinks';

interface Props {
	renderPromoCode?: () => React.ReactElement;
	renderBefore?: React.ReactElement[];
	promoCode?: string;
}

const Bottom: React.FunctionComponent<Props> = React.memo(props => {
	const { Bottom: css, SearchForm } = useTheme('SearchForm');
	const { promoCode } = props;

	const {
		SearchForm: { enableComplexRoute, proMode, payByMiles, offerHotels, additionalLinks }
	} = useConfig();

	const BottomRight = useRenderers().SearchFormBottomRight;
	const isControlsAvailable = (enableComplexRoute && !proMode) || offerHotels;

	return (
		<div className={cn(SearchForm.row, css.bottom)}>
			{props.renderBefore}
			{isControlsAvailable && (
				<div className={css.controls}>
					{enableComplexRoute && !proMode && <MultiCity />}
					{additionalLinks && <AdditionalLinks />}
					{offerHotels && <OfferHotels />}
				</div>
			)}

			{props.renderPromoCode ? (
				props.renderPromoCode()
			) : (
				<SearchFormPromoCode promoCode={promoCode} status={promoCode ? PromoCodeStatus.Provided : undefined} />
			)}
			{payByMiles && <PayByMiles />}
			{BottomRight && <BottomRight />}
			{/*<Additional />*/}
		</div>
	);
});

export default Bottom;
